import React from 'react';
import { FormSection } from 'redux-form';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { RadioField } from 'src/jbc-front/components/Form';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { getEmployeeFormValues } from 'src/reducers/employees/employees';
import selector from 'src/utils/Utils';

const EmployeeMotivation = ({ payrollRulesGroups, selectedPayrollRuleGroup }) => {
  const { t } = useTranslation();
  const DILIGENCE_TARGET = [
    { value: '1', label: t('features.Employees.components.EmployeeMotivation.enable') },
    { value: '0', label: t('features.Employees.components.EmployeeMotivation.disable') }
  ];
  const hasMotivationAllowance = _.find(payrollRulesGroups, { id: selectedPayrollRuleGroup.clientPayrollRulesGroupId })
    ?.gotMotivationAllowance;

  return (
    <>
      {hasMotivationAllowance && (
        <div>
          <FormSection name="employee">
            <h4>{t('features.Employees.components.EmployeeMotivation.motivation_setting')}</h4>
            <RadioField
              parse={value => value === '1'}
              format={value => (value ? '1' : '0')}
              label={t('features.Employees.components.EmployeeMotivation.enable_calculate_motivation')}
              name="isCalculateMotivation"
              options={DILIGENCE_TARGET}
            />
          </FormSection>
        </div>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  payrollRulesGroups: getSelectOptions(state, 'payrollRulesGroups'),
  selectedPayrollRuleGroup: selector(getEmployeeFormValues(state), 'employeePayrollRule')
});

export default connect(mapStateToProps)(EmployeeMotivation);
